export const KeycloakErrorHandlerConfig = Object.freeze({
  errorInit: {
    context: '[Keycloak Error] Context: ',
  },
});
